<template>
	<li class="kar__item">
		<div class="kar__publication" v-html="citation"></div>
		<div class="kar__links">
			<button class="kar__link kar__toggle" :class="showAbstract ? 'abstract-visible' : ''" v-if="publication.abstract != null" @click="toggleAbstract">Abstract</button>
			<a class="kar__link" v-if="publication.kar_url" :href="publication.kar_url" target="_blank">View in KAR</a>
			<template v-if="publication.file">
			<span class="kar__link">
				<i class="fa file-icon" :class="publication.file_type == 'application/pdf' ? 'file-pdf' : 'file-ppt'"></i>
				<a :href="publication.file" target="_blank">View full text</a>
			</span>
			</template>
			<div class="kar__abstract" :class="showAbstract ? 'visible' : ''">{{publication.abstract}}</div>
		</div>
	</li>
</template>

<script>
export default {
	props: {
		publication: Object,
	},
	data() {
		return {
			showAbstract: false,
			citation: '',
		};
	},
	mounted() {
		this.citationSetup();
	},
	methods: {
		toggleAbstract() {
			this.showAbstract = !this.showAbstract;
		},
		citationSetup() {
			// finds all UoK authors of this publication and rebuild citation with their names bold
			var UoKAuthors = this.findUoKAuthors();
			this.citation = this.rebuildCitation(UoKAuthors);
		},
		findUoKAuthors() {
			// return array of all UoK authors in this publication
			// this is done by checking whether their email ends in '@kent.ac.uk'

			var authors = this.publication.authors;
			var UoKAuthors = new Array();

			authors.forEach((author) => {
				if (author.email) {
				var email = author.email;
				if (
					email.indexOf(
					"@kent.ac.uk",
					email.length - "@kent.ac.uk".length
					) !== -1
				) {
					UoKAuthors.push(author);
				}
				}
			});

			return UoKAuthors;
		},
		rebuildCitation(UoKAuthors) {
			// get the reference type of citation
			var citationType = Object.keys(this.publication.citations)[0];
			// get citation of publication
			var citation = this.publication.citations[Object.keys(this.publication.citations)[0]];
			// for every UoK author replace their name with their name wrapped in <b> tags
			// as every reference type diplays names differently we must account for this
			switch (citationType) {
				case "APA": {
					UoKAuthors.forEach((author) => {
						var citationName = author.family + ", " + author.given.charAt(0) + ".";
						citation = citation.replace(citationName, "<b><a href='"+author.url+"'>"+citationName+"</a></b>")
					});
				}
				break;
				case "HARVARD": {
					UoKAuthors.forEach((author) => {
						var citationName = author.family + ", " + author.given.charAt(0) + ".";
						citation = citation.replace(citationName, "<b><a href='"+author.url+"'>"+citationName+"</a></b>")
					});
				}
				break;
			}
			return citation;
		},
	},
};
</script>
